import { __ } from '@wordpress/i18n'

import React from 'react'
import PropTypes from 'prop-types'
import {
  Teaser,
  Image,
  Content,
  HoverContent,
  Title,
  Excerpt,
  DateBadge,
  Link,
  ReadMore,
} from './custom.styled'
import placeholder from '../../../images/placeholder.jpg'

const IssueTeaser = ({ post, isSlider = false, isEditor = false }) => {
  return (
    post && (
      <Teaser isSlider={isSlider}>
        <Image>
          <img
            src={post.image.url || placeholder}
            alt={post.image.alt || post.image.title}
          />
        </Image>
        <Content>
          <DateBadge>
            <span>
              ISSUE{' '}
              {post.fields.issuenumber ? post.fields.issuenumber + ' ' : ''}-{' '}
              {post.date}
            </span>
          </DateBadge>
          <Title dangerouslySetInnerHTML={{ __html: post.title }}></Title>
        </Content>
        {post.text && (
          <HoverContent>
            <DateBadge>
              <span>
                ISSUE{' '}
                {post.fields.issuenumber ? post.fields.issuenumber + ' ' : ''}-{' '}
                {post.date}
              </span>
            </DateBadge>
            <Excerpt dangerouslySetInnerHTML={{ __html: post.text }} />
          </HoverContent>
        )}
        {!isEditor && <Link href={post.link.url}></Link>}
        <ReadMore>
          {__('Read More', 'dhsv_theme')}
          <i className="las la-arrow-circle-right"></i>
        </ReadMore>
      </Teaser>
    )
  )
}

IssueTeaser.propTypes = {
  post: PropTypes.object,
  isSlider: PropTypes.bool,
  isEditor: PropTypes.bool,
}

export default IssueTeaser
